import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import fullTime from 'flarum/common/helpers/fullTime';
import ItemList from 'flarum/common/utils/ItemList';
import LinkButton from 'flarum/common/components/LinkButton';
import GiveBadgeModal from './GiveBadgeModal';
export default class BadgeModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = false;
  }
  className() {
    return 'Modal--small';
  }
  title() {
    return app.translator.trans('v17development-flarum-badges.forum.badge_information');
  }
  content() {
    return m("div", null, m("div", {
      className: "Modal-body"
    }, this.data().toArray()), m("div", {
      className: "Modal-footer"
    }, m(LinkButton, {
      href: app.route('badges.item', {
        id: this.attrs.badge.id()
      }),
      className: 'Button',
      style: {
        margin: '0 10px'
      }
    }, app.translator.trans('v17development-flarum-badges.forum.badge.badge_details')), this.attrs.userBadgeData && app.forum.attribute('canGiveBadge') && m(Button, {
      className: 'Button Button--primary',
      onclick: () => {
        if (confirm(app.translator.trans('v17development-flarum-badges.forum.moderation.remove_badge_confirm'))) {
          this.loading = true;
          this.attrs.userBadgeData.delete().then(() => this.hide());
        }
      },
      loading: this.loading
    }, app.translator.trans('v17development-flarum-badges.forum.moderation.remove_badge'))));
  }
  data() {
    const items = new ItemList();

    // Badge name
    items.add('name', m("div", {
      className: 'BadgeModalListItem'
    }, m("p", null, m("b", null, app.translator.trans('v17development-flarum-badges.forum.badge.name'), ":")), m("p", null, this.attrs.badge.name())));

    // Badge description
    items.add('description', m("div", {
      className: 'BadgeModalListItem'
    }, m("p", null, m("b", null, app.translator.trans('v17development-flarum-badges.forum.badge.description'), ":")), m("p", null, this.attrs.badge.description())));

    // Badge earning reason
    if (this.attrs.userBadgeData && (this.attrs.userBadgeData.description() || app.forum.attribute('canGiveBadge'))) {
      items.add('earning_reason', m("div", {
        className: 'BadgeModalListItem'
      }, m("p", null, m("b", null, app.translator.trans('v17development-flarum-badges.forum.badge.earning_reason'), ":")), m("p", null, this.attrs.userBadgeData.description() ? this.attrs.userBadgeData.description() : m("i", null, app.translator.trans('v17development-flarum-badges.forum.badge.no_earning_reason'))), m("p", null, app.forum.attribute('canGiveBadge') && m("a", {
        href: '#',
        onclick: e => {
          e.preventDefault();
          app.modal.show(GiveBadgeModal, {
            badge: this.attrs.userBadgeData
          });
        }
      }, app.translator.trans('v17development-flarum-badges.forum.badge.update_earning_reason')))));
    }

    // Badge earned on
    if (this.attrs.userBadgeData) {
      items.add('earned_date', m("div", {
        className: 'BadgeModalListItem'
      }, m("p", null, m("b", null, app.translator.trans('v17development-flarum-badges.forum.badge.earned_on'), ":")), m("p", null, fullTime(this.attrs.userBadgeData.assignedAt()))));
    }

    // Badge category
    if (this.attrs.userBadgeData) {
      items.add('category', m("div", {
        className: 'BadgeModalListItem'
      }, m("p", null, m("b", null, app.translator.trans('v17development-flarum-badges.forum.badge.category'), ":")), m("p", null, this.attrs.badge.category() && this.attrs.badge.category().name(), !this.attrs.badge.category() && app.translator.trans('v17development-flarum-badges.forum.uncategorized'))));
    }

    // Badge category
    if (this.attrs.badge && this.attrs.badge.earnedAmount()) {
      items.add('earned_amount', m("div", {
        className: 'BadgeModalListItem'
      }, m("p", null, app.translator.trans('v17development-flarum-badges.forum.badge.earned_count', {
        count: this.attrs.badge.earnedAmount(),
        b: m("b", null)
      }))));
    }
    return items;
  }
}
flarum.reg.add('v17development-user-badges', 'forum/components/BadgeModal', BadgeModal);